<template>
  <div
    ref="rootElem"
    class="nav-collapsible"
    :class="{
      'nav-collapsible--open': open,
      [`nav-collapsible--${variant}`]: variant,
    }"
  >
    <div class="nav-collapsible__action">
      <slot name="action" :toggle="toggle" :open="open"></slot>
    </div>
    <div
      ref="navCollapsibleContent"
      class="nav-collapsible__content"
      :aria-hidden="open ? 'false' : 'true'"
    >
      <slot name="content" :open="open"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavCollapsible',
  props: {
    isOpen: Boolean,
    variant: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: this.isOpen,
    }
  },
  watch: {
    async open() {
      this.getAndSetHeight()
    },
    isOpen: {
      immediate: true,
      handler() {
        this.open = this.isOpen
      },
    },
  },
  mounted() {
    this.getAndSetHeight()
    window.addEventListener('resize', this.getAndSetHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getAndSetHeight)
  },
  methods: {
    async getHeight() {
      const targetEl = this.$refs.navCollapsibleContent
      if (!targetEl) return
      const parentEl = targetEl.parentNode
      if (!parentEl) return

      const cloneEl = targetEl.cloneNode(true)
      cloneEl.style.maxHeight = 'none'
      cloneEl.style.opacity = '0'
      parentEl.appendChild(cloneEl)
      await this.$nextTick()
      const clientHeight = cloneEl.clientHeight
      parentEl.removeChild(cloneEl)
      return clientHeight
    },
    toggle() {
      const state = !this.open
      const container = this.$refs.navCollapsibleContent

      container.style.height = this.getHeight() + 'px'
      this.open = state
      this.$emit(state ? 'open' : 'close')
    },
    setHeight(height) {
      if (height > 0) {
        this.$refs.navCollapsibleContent.style.height = height + 'px'
      }
      return height
    },
    getAndSetHeight() {
      this.setHeight(this.getHeight())
      this.$refs.navCollapsibleContent.style.height = 'auto'
    },
  },
}
</script>

<style lang="postcss" scoped>
.nav-collapsible {
  border-bottom: 1px solid var(--c-secondary-neutral-3);
}

.nav-collapsible__action {
  user-select: none;
  cursor: pointer;
}

.nav-collapsible__content {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: opacity 300ms ease-in-out, max-height 100ms ease-in-out;
}

.nav-collapsible--open > .nav-collapsible__content {
  opacity: 1;
  max-height: max(100vh, 2000px);
  transition: opacity 300ms ease-in-out, max-height 1000ms ease-in-out;
}

@media (--lg) {
  /* Needs to be defined on the level of the content to prevent layer issues */
  .nav-collapsible--secondary > .nav-collapsible__content {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(var(--navigation-height) - 1px);
    z-index: var(--z-index-overlay);
  }

  .nav-collapsible__content {
    transition: opacity 200ms ease-in-out, max-height 200ms ease-in-out;
  }

  .nav-collapsible--open > .nav-collapsible__content {
    transition: opacity 200ms ease-in-out, max-height 200ms ease-in-out;
  }
}
</style>
